<template lang="pug">
b-modal#approveTicketAffiliate(
  ref="approveTicketAffiliate"
  :title='$t("ui.combine.approve_affiliate_ticket")'
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th(colspan="2")
              span {{ $t("ui.withdrawal") }}
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.account_id") }}
            td
              span {{ ticketDetail.account_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:title="$n(ticketDetail.amount, 'currency')" :class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.recipient_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.recipient_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.recipient_bank_acc_holder }}
          tr(v-if="['ARS','AUD'].includes(getCurrencyCode)")
            td
              span {{ ['AUD'].includes(getCurrencyCode) ? $t("ui.bsb") : $t("ui.cuit") }}
            td
              span {{ ticketDetail.target_bank_acc_remark }}
          tr(v-if="['AUD'].includes(getCurrencyCode)")
            td
              span {{ $t("ui.payid") }}
            td
              span {{ ticketDetail.target_bank_acc_remark_2 }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          template(v-if="ticketDetail.exchange_currency != null")
            tr
              td
                span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchanged_amount") }}
              td
                span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}
          
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
    b-form-group(:label="$t('ui.sender_bank')").mb-0
      BankListAutoWithdrawal(
        ref="senderBank"
        size="sm"
        type="array"
        :dirty="$v.sender_bank.$dirty"
        :error="$v.sender_bank.$error"
        v-model.trim.lazy="$v.sender_bank.$model"
        :disabled="loading"
        :operatorID="parentId"
        :externalID="ticketDetail.external_id"
        @min-limit-updated="handleMinLimitUpdated"
        @min-limit-changed="handleMinLimitChanged"
      )
      ValidateResult(:value="$v.sender_bank" :name="$t('ui.sender_bank')")
      small.text-info.ml-2(v-if="minLimit != null") {{ $t("ui.min_withdrawal") }}: {{ minLimit }}
    b-form-group(:label="$t('ui.remark')" v-if="ticketDetail.status.trim().toUpperCase() != 'REJECTED'").mb-0
      DebounceInput(
        size="sm"
        type="text"
        v-model="remark"
        :disabled="loading"
      )
    div(slot="modal-footer")
      SubmitButton.float-right(icon="fa fa-check" :text="$t('ui.approve')" @click="approveTicket()" size="sm" variant="success" v-if="showApproveBtn()" :loading="loading")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary" :loading="loading").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import BankListAutoWithdrawal from "@/library/BankListAutoWithdrawalAff";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankListAutoWithdrawal,
    ValidateResult
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    },
    parentId:{
      type: String,
      default: ""
    },
    memberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      memberDetail: null,
      sender_bank: '',
      remark: '',
      minLimit: null,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  validations: {
    sender_bank: {
      required
    },
  },
  methods: {
    showApproveBtn() {
      if (['AUDIT'].includes(this.ticketDetail.status.trim().toUpperCase()))
        return true;
      else
        return false;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.sender_bank = '';
      this.remark = '';
      this.minLimit = null;
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    approveTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // Check if exchanged_amount is less than minLimit
        if (this.ticketDetail && this.ticketDetail.exchange_currency != null && 
            this.ticketDetail.exchanged_amount != null && this.minLimit != null) {
          const exchangedAmount = parseFloat(this.ticketDetail.exchanged_amount);
          const minLimitValue = parseFloat(this.minLimit);
          
          if (!isNaN(exchangedAmount) && !isNaN(minLimitValue) && exchangedAmount < minLimitValue) {
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.minWithdrawalNotMet"), "error");
            return;
          }
        }
        this.confirmApproveTicket();
      }
    },
    confirmApproveTicket: function() {
      let url = '';
      var payment_mode = this.sender_bank.split(' - ')[1].trim();

      if (["GSPAY","LUXEPAY","LUXEPAYQR","FPAY","FPAYQR","AMOPAY","METAPAY","DGPAYQR","SECRETPAYQRMY","MPIN",
            "VADERPAY","VADERPAYQR","PEPAY","NOVAPAY","PEPAYPIN","GSPAYQR"].includes(payment_mode)) {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.notSupportedWithdrawalPG"), "error");
        return;
      }

      switch(payment_mode) {
        //argentina
        case "MGMPAY":
          url = config.withdrawalMGMPayAffUrl();
          break;
        case "ROCKETX":
          url = config.withdrawalROCKETXArsAffUrl();
          break;
        //russia
        case "INPAY":
          url = config.withdrawalINPayAffUrl();
          break;
        case "ONEPAY":
          url = config.withdrawalONEPayAffUrl();
          break;
        //argentina && russia
        case "HIGHHELP":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalHIGHHELPArsAffUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalHIGHHELPRubAffUrl();
          }
          break;
        case "MERCURIO":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalMERCURIOArsAffUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalMERCURIORubAffUrl();
          }
          break;
        case "JUPITER":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalJUPITERArsAffUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalJUPITERRubAffUrl();
          }
          break;
        case "PROPAYLLER":
          if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalPROPAYLLERRubAffUrl();
          }
          break;
        case "AMPAY":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalAMPayArsAffUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalAMPayRubAffUrl();
          }
          break;
        case "NIRVANA":
          if (this.getCurrencyCode == "ARS") {
            url = config.withdrawalNIRVANAArsAffUrl();
          } else if (this.getCurrencyCode == "RUB") {
            url = config.withdrawalNIRVANARubAffUrl();
          } else if (this.getCurrencyCode == "AUD") {
            url = config.withdrawalNIRVANARubAffUrl();
          }
          break;
        //malaysia
        case "DGPAY":
          url = config.withdrawalDGPayAffUrl();
          break;
        case "TRUEPAY":
          url = config.withdrawalTRUEPayAffUrl();
          break;
        case "ONEPAYMY":
          url = config.withdrawalONEPayMYAffUrl();
          break;
        case "TRUSTPAY":
          url = config.withdrawalTRUSTPayAffUrl();
          break;
        case "EPICPAY":
          url = config.withdrawalEPICPayAffUrl();
          break;
        case "SECUREPAY":
          url = config.withdrawalSECUREPayAffUrl();
          break;
        case "JPAY":
          url = config.withdrawalJPayAffUrl();
          break;
        case "TTPAY":
          url = config.withdrawalTTPayAffUrl();
          break;
        case "AUTOPAY":
          url = config.withdrawalAUTOPayAffUrl();
          break;
        case "SECRETPAYMY":
          url = config.withdrawalSECRETPayMYAffUrl();
          break;
        case "VPAY":
          url = config.withdrawalVPayAffUrl();
          break;
        case "DIERPAY":
          url = config.withdrawalDIREPayAffUrl();
          break;
        //vietnam
        case "YESPAY":
          url = config.withdrawalYESPayAffUrl();
          break;
        case "BESTPAY":
          url = config.withdrawalBESTPayAffUrl();
          break;
        case "TIMEPAY":
          url = config.withdrawalTIMEPayAffUrl();
          break;
        case "DAYANGPAY":
          url = config.withdrawalDAYANGPayAffUrl();
          break;
        case "ONEVNPAY":
          url = config.withdrawalONEVNPayAffUrl();
          break;
        case "CLUBSPAY":
          url = config.withdrawalCLUBSPayAffUrl();
          break;
        case "SECRETPAY":
          url = config.withdrawalSECRETPayAffUrl();
          break;
        case "WOWPAY":
          url = config.withdrawalWOWPayAffUrl();
          break;
        case "UBIT":
          url = config.withdrawalUBITAffUrl();
          break;
        case "GLOBALPAY":
          url = config.withdrawalGLOBALPayAffUrl();
          break;
        case "BCATPAYVN":
          url = config.withdrawalBCATPayVNAffUrl();
          break;
        case "SOLIDPAY":
          url = config.withdrawalSOLIDPayAffUrl();
          break;
        case "KPAYVN":
          url = config.withdrawalKPayVNAffUrl();
          break;
        //bangladesh
        case "TIGERPAY":
          url = config.withdrawalTIGERPayAffUrl();
          break;
        case "TAKAPAY":
          url = config.withdrawalTAKAPayAffUrl();
          break;
        case "BCATPAY":
          url = config.withdrawalBCATPayAffUrl();
          break;
      }

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_id: this.ticketDetail.id,
        remark: this.remark,
        audit_by: this.$store.getters.loginId,
      };

      json.target_bank_id = this.ticketDetail.recipient_bank_id;
      json.ref_no = this.ticketDetail.ref_no;
      // json.sender_bank_id = this.sender_bank.split(' - ')[0].trim();
      json.payment_mode = this.sender_bank.split(' - ')[1].trim();
      json.amount = this.ticketDetail.amount;
      json.target_bank_acc_holder = this.ticketDetail.recipient_bank_acc_holder;

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.approveTicketAffiliate.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.approveTicketAffiliate.hide();
    },
    handleMinLimitUpdated: function(data) {
      // Store min_limit when balance data is received
      if (this.sender_bank && this.sender_bank.includes(' - ')) {
        var payment_mode = this.sender_bank.split(' - ')[1].trim();
        if (payment_mode === data.pg) {
          this.minLimit = data.min_limit;
        }
      }
    },
    handleMinLimitChanged: function(data) {
      // Update min_limit when selection changes
      this.minLimit = data.min_limit;
    },
  }
};
</script>
